import React from 'react';
import { useMediaAttachment } from '../../../hooks/useMediaAttachment';

export const DocumentAttachment = ({ mediaId, filename, caption, mimeType }: { mediaId: string, filename?: string, caption?: string, mimeType?: string }) => {
    const { url, status, downloadMedia } = useMediaAttachment(mediaId);

    return (
        <div className="d-flex flex-column gap-1">
            <div className="d-flex align-items-center p-2 rounded gap-2 cursor-pointer" style={{ backgroundColor: 'rgba(0,0,0,0.05)', minWidth: '200px' }} onClick={(e) => {
                if (status === 'IDLE' || status === 'ERROR') {
                    e.stopPropagation();
                    downloadMedia();
                }
            }}>
                <div className="flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle" style={{ width: '40px', height: '40px', backgroundColor: 'rgba(0,0,0,0.1)' }}>
                    <i className="ri-file-text-line fs-20 text-secondary"></i>
                </div>
                <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <div className="text-truncate fw-semibold" style={{ fontSize: '14px' }}>
                        {filename || 'Documento'}
                    </div>
                    {status === 'ERROR' && (
                        <div className="text-danger" style={{ fontSize: '11px' }}>
                            <i className="ri-refresh-line me-1"></i> Reintentar descarga
                        </div>
                    )}
                    {status === 'IDLE' && (
                        <div className="text-primary" style={{ fontSize: '11px' }}>
                            <i className="ri-download-2-line me-1"></i> Descargar
                        </div>
                    )}
                    {status === 'SUCCESS' && mimeType && (
                        <div className="text-muted" style={{ fontSize: '11px' }}>
                            {mimeType.split('/')[1]?.toUpperCase() || 'ARCHIVO'}
                        </div>
                    )}
                </div>
                <div className="flex-shrink-0">
                    {status === 'LOADING' ? (
                        <div className="spinner-border spinner-border-sm text-primary" role="status" />
                    ) : status === 'SUCCESS' && url ? (
                        <a href={url} download={filename || 'documento'} className="btn btn-sm btn-link p-1" onClick={(e) => e.stopPropagation()}>
                            <i className="ri-download-cloud-2-line fs-18"></i>
                        </a>
                    ) : null}
                </div>
            </div>
            {caption && <div className="text-break" style={{ whiteSpace: 'pre-wrap' }}>{caption}</div>}
        </div>
    );
};
